export interface VenueCoord {
  id: string;
  lat: number;
  lng: number;
  mapQuery: string;
}

export const venueCoords: VenueCoord[] = [
  // Tarihi Yerler
  { id: "ulu-cami", lat: 40.1836, lng: 29.0611, mapQuery: "Ulu+Cami+Osmangazi+Bursa+Turkey" },
  { id: "yesil-cami", lat: 40.1812, lng: 29.0694, mapQuery: "Yesil+Cami+Yildirim+Bursa+Turkey" },
  { id: "yesil-turbe", lat: 40.1808, lng: 29.0697, mapQuery: "Yesil+Turbe+Bursa+Turkey" },
  { id: "osman-gazi-turbesi", lat: 40.1869, lng: 29.0572, mapQuery: "Osman+Gazi+Turbesi+Tophane+Bursa+Turkey" },
  { id: "hanlar-bolgesi", lat: 40.1834, lng: 29.0601, mapQuery: "Hanlar+Bolgesi+Kapali+Carsi+Bursa+Turkey" },
  { id: "muradiye-camii", lat: 40.1878, lng: 29.0539, mapQuery: "Muradiye+Camii+Kulliyesi+Bursa+Turkey" },
  { id: "bursa-kalesi", lat: 40.1872, lng: 29.0569, mapQuery: "Bursa+Kalesi+Tophane+Parki+Bursa+Turkey" },
  // Lezzet Durakları
  { id: "kebapci-iskender", lat: 40.1835, lng: 29.0614, mapQuery: "Kebapci+Iskender+Bursa+Turkey" },
  { id: "iskenderoglu", lat: 40.1837, lng: 29.0620, mapQuery: "Iskenderoglu+Bursa+Turkey" },
  { id: "haci-bey", lat: 40.1840, lng: 29.0590, mapQuery: "Haci+Bey+Restaurant+Bursa+Turkey" },
  { id: "cumalikizik-sofrasi", lat: 40.2019, lng: 29.1342, mapQuery: "Cumalikizik+Koyu+Yildirim+Bursa+Turkey" },
  { id: "pideciler-carsisi", lat: 40.1833, lng: 29.0605, mapQuery: "Eski+Pideciler+Carsisi+Bursa+Turkey" },
  { id: "uludag-kebap", lat: 40.2065, lng: 29.0201, mapQuery: "Uludag+Kebap+Evi+Nilufer+Bursa+Turkey" },
  { id: "hamdi-restaurant", lat: 40.2021, lng: 29.0175, mapQuery: "Hamdi+Restaurant+Nilufer+Bursa+Turkey" },
  // Eğlence
  { id: "extrempark", lat: 40.2230, lng: 28.9685, mapQuery: "Extrempark+Ataturk+Kent+Ormani+Nilufer+Bursa" },
  { id: "hayvanat-bahcesi", lat: 40.1965, lng: 29.0311, mapQuery: "Bursa+Hayvanat+Bahcesi+Turkey" },
  { id: "aqua-bursa", lat: 40.2080, lng: 29.0150, mapQuery: "Aqua+Bursa+Su+Parki+Nilufer+Turkey" },
  { id: "bursa-panoramik", lat: 40.1344, lng: 29.1122, mapQuery: "Panoramik+Bursa+Uludag+Turkey" },
  { id: "citypark-sinema", lat: 40.2080, lng: 29.0155, mapQuery: "CityPark+AVM+Nilufer+Bursa+Turkey" },
  // Konaklama
  { id: "gumusçpala-termal", lat: 40.1904, lng: 29.0388, mapQuery: "Gumuspala+Termal+Hotel+Cekirge+Bursa+Turkey" },
  { id: "kervansaray-termal", lat: 40.1908, lng: 29.0381, mapQuery: "Kervansaray+Termal+Hotel+Cekirge+Bursa+Turkey" },
  { id: "hilton-bursa", lat: 40.2042, lng: 29.0080, mapQuery: "Hilton+Garden+Inn+Bursa+Turkey" },
  { id: "boutique-1453", lat: 40.1869, lng: 29.0572, mapQuery: "Boutique+Hotel+1453+Tophane+Bursa+Turkey" },
  { id: "goynuk-termal", lat: 40.4013, lng: 29.7644, mapQuery: "Goynuk+Termal+Resort+Karacabey+Bursa+Turkey" },
  { id: "cumalikizik-butik", lat: 40.2019, lng: 29.1342, mapQuery: "Cumalikizik+Butik+Otel+Yildirim+Bursa+Turkey" },
  // Doğa ve Rotalar
  { id: "bursa-teleferik", lat: 40.1950, lng: 29.0611, mapQuery: "Bursa+Teleferik+Namazgah+Turkey" },
  { id: "botanik-park", lat: 40.1912, lng: 29.0392, mapQuery: "Bursa+Botanik+Parki+Cekirge+Turkey" },
  { id: "uludag-milli-park", lat: 40.1266, lng: 29.1044, mapQuery: "Uludag+Milli+Parki+Bursa+Turkey" },
  { id: "golyazi", lat: 40.2089, lng: 28.7739, mapQuery: "Golyazi+Koyu+Uluabat+Bursa+Turkey" },
  { id: "karacabey-longozu", lat: 40.2189, lng: 28.7639, mapQuery: "Karacabey+Longozu+Bursa+Turkey" },
  // Gezilecek Yerler
  { id: "cumalikizik-koy", lat: 40.2019, lng: 29.1342, mapQuery: "Cumalikizik+Koyu+UNESCO+Bursa+Turkey" },
  { id: "kapali-carsi", lat: 40.1833, lng: 29.0601, mapQuery: "Bursa+Kapali+Carsisi+Osmangazi+Turkey" },
  { id: "bursa-muzesi", lat: 40.1960, lng: 29.0544, mapQuery: "Bursa+Muzesi+Kultur+Parki+Turkey" },
  { id: "kent-muzesi", lat: 40.1834, lng: 29.0605, mapQuery: "Bursa+Kent+Muzesi+Osmangazi+Turkey" },
  { id: "mudanya-mutareke", lat: 40.3788, lng: 28.8853, mapQuery: "Mudanya+Mutareke+Evi+Bursa+Turkey" },
  { id: "nilufer-imareti", lat: 40.1836, lng: 29.0608, mapQuery: "Nilufer+Hatun+Imareti+Osmangazi+Bursa+Turkey" },
];

export const getCoordsById = (id: string): VenueCoord | undefined =>
  venueCoords.find((c) => c.id === id);
